import { Component } from '@angular/core';

@Component({
  selector: 'spark-mpm-store-details',
  templateUrl: './store-details.component.html',
  styleUrls: ['./store-details.component.scss']
})
export class MpmStoreDetailsComponent {
  constructor() {}

  public onClick(): void {
    window.open('https://store.mikepero.co.nz/login', '_blank');
  }
}
